module.exports = __webpack_public_path__ + "img/img23.3e58fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img23.png
// module id = 264
// module chunks = 0